import { render, staticRenderFns } from "./EditorBlockRecordVideo.vue?vue&type=template&id=519a4ae1"
import script from "./EditorBlockRecordVideo.vue?vue&type=script&lang=js"
export * from "./EditorBlockRecordVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports